import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/sumeet/webdesign/prateeksha.com/nextjs-live/src/app/(blog)/blog/[slug]/BlogPage.jsx");
